import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { AlternariaSettingsModal } from './AlternariaSettingsModal'

const permission = 'EDIT_ALTERNARIA_DSV_THRESHOLD'

export const AlternariaSettingsTitleLink = () => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        key="spray-thresholds-menu-item"
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              alternariaSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Edit Spray Thresholds')}
      </ResponsiveMenuItem>
      <AlternariaSettingsModal key="spray-thresholds-modal" data-role="modal" />
    </>,
  )

  return titleLink
}
